// extracted by mini-css-extract-plugin
export default {"select":"Select_select__KSHVN","label":"Select_label__1IGNd"};